import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, DatePicker, SelectMenu, toast } from '@livable/saas-react-components';
import { Button, FormControl, InputAdornment, MenuItem, OutlinedInput, TextField, Grid, Typography, InputLabel } from '@mui/material';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CheckModal from 'src/components/transactions/CheckModal';
import { useStore } from 'src/stores';
import { verifyPaymentInitialValues, verifyPaymentSchema } from 'src/utils/formValidation/Transaction';
import useStyles from './styles';
export const PostPaymentForm = observer(_ref => {
  let accountId = _ref.accountId,
    handleClose = _ref.handleClose,
    propertyId = _ref.propertyId,
    handleRefreshTrigger = _ref.handleRefreshTrigger;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const paymentTypes = ['CheckMoneyOrder', 'Venmo', 'Zelle', 'Other'];
  const today = new Date();
  const priorDate = new Date(new Date().setDate(today.getDate() - 60));
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    payInProcess = _useState2[0],
    setPayInProcess = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    chechIsOpen = _useState4[0],
    setCheckIsOpen = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    checked = _useState6[0],
    setChecked = _useState6[1];
  const checkPayment = async data => {
    const resp = await store.transaction.checkPaymentAsync.run(data);
    return resp;
  };
  const verifyPayment = async data => {
    const resp = await store.transaction.verifyPaymentAsync.run(data);
    return resp;
  };
  const callback = resp => {
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['The payment has been posted.']
      }); // ? i18n
      handleClose(false);
      store.transaction.setUpdateData();
    }
  };
  const formik = useFormik({
    initialValues: verifyPaymentInitialValues,
    onSubmit: async values => {
      setPayInProcess(true);
      const data = {
        amount: values.amount,
        memo: values.memo,
        notes: values.notes,
        postDate: moment(values.postDate).format(moment.HTML5_FMT.DATE),
        propertyId,
        referenceNumber: values.referenceNumber,
        type: values.type,
        userAccountId: accountId
      };
      verifyPayment(data).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful && resp.response.lateFeeVoids.length === 0) {
          return checkPayment(data).then(callback);
        } else setCheckIsOpen(true);
      }).finally(() => {
        handleRefreshTrigger();
        setPayInProcess(false);
      });
    },
    validationSchema: verifyPaymentSchema()
  });
  useEffect(() => {
    if (!checked) return;
    const _formik$values = formik.values,
      amount = _formik$values.amount,
      memo = _formik$values.memo,
      notes = _formik$values.notes,
      postDate = _formik$values.postDate,
      referenceNumber = _formik$values.referenceNumber,
      type = _formik$values.type;
    const data = {
      amount,
      memo,
      notes,
      postDate: moment(postDate).format(moment.HTML5_FMT.DATE),
      propertyId,
      referenceNumber,
      type: type,
      userAccountId: accountId
    };
    checkPayment(data).then(callback);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);
  return /*#__PURE__*/React.createElement("form", {
    id: "payment",
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formFields
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "sort-by-month-selector",
    label: t('resident_account.select_payment_type'),
    labelId: "sort-by-selector-label",
    onChange: e => formik.setFieldValue('type', e.target.value),
    value: formik.values.type,
    className: classes.filterSelector
  }, paymentTypes.map(type => /*#__PURE__*/React.createElement(MenuItem, {
    key: type,
    value: type
  }, type === 'CheckMoneyOrder' ? t('resident_account.check_money_order') : type)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, t('resident_account.enter_amount')), /*#__PURE__*/React.createElement(OutlinedInput, {
    error: formik.touched.amount && Boolean(formik.errors.amount),
    id: "amount",
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      formik.handleChange(e);
    },
    label: t('resident_account.enter_amount'),
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    placeholder: "0.00",
    type: "number",
    value: formik.values.amount
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "username"
  }, t('resident_account.reference_number')), /*#__PURE__*/React.createElement(OutlinedInput, {
    error: formik.touched.referenceNumber && Boolean(formik.errors.referenceNumber),
    id: "referenceNumber",
    onChange: e => formik.handleChange(e),
    label: t('resident_account.reference_number'),
    type: "text",
    value: formik.values.referenceNumber
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => formik.setFieldValue('postDate', date),
    format: "MM/dd/yy",
    minDate: priorDate,
    value: formik.values.postDate,
    label: t('resident_account.post_date')
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('resident_account.late_fees_automatically_credited'))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "memo",
    label: t('resident_account.memo'),
    name: "memo",
    onChange: e => {
      if (e.target.value.length <= 255) formik.handleChange(e);
    },
    type: "text",
    value: formik.values.memo,
    variant: "outlined",
    multiline: true,
    maxRows: 10,
    minRows: 4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", formik.values.memo.length, "/255)")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "notes",
    label: t('resident_account.notes'),
    name: "notes",
    onChange: e => {
      if (e.target.value.length <= 255) formik.handleChange(e);
    },
    type: "text",
    value: formik.values.notes,
    variant: "outlined",
    multiline: true,
    maxRows: 10,
    minRows: 4
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", formik.values.notes.length, "/255)")))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: payInProcess,
    onClick: () => handleClose(false),
    'custom-attribute': '458-post-payment-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !formik.isValid || payInProcess,
    form: "payment",
    type: "submit",
    variant: "contained",
    'custom-attribute': '459-post-payment-modal'
  }, t('buttons.submit')), /*#__PURE__*/React.createElement(CheckModal, {
    handleClose: () => setCheckIsOpen(false),
    isOpen: chechIsOpen,
    setChecked: setChecked
  }))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: payInProcess
  }));
});